import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Mount this once near the top of your app (e.g. in App.jsx, alongside your <Routes>).
// Press Ctrl+Shift+A (Cmd+Shift+A on Mac) from anywhere on the site to jump to /admin-login.
export default function AdminShortcut() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      const isModifierCombo = (e.ctrlKey || e.metaKey) && e.shiftKey;
      if (isModifierCombo && e.key.toLowerCase() === 'a') {
        e.preventDefault();
        navigate('/admin-login');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return null; // renders nothing, just listens
}